import { usePostHttp } from "../../http.hook";

// biome-ignore lint/suspicious/noEmptyInterface: <explanation>
interface IResponse {}

export function useReleaseGstTransactionAdminHttp() {
	return usePostHttp<null, IResponse>({
		path: "/admin/payouts/transactions/:id/release-gst",
	});
}
